import { useMemo } from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { HeroDE } from "../../components/HeroDE";
import { WhyUs } from "../../components/WhyUs";
import { Services } from "../../components/Services";
import { CTA } from "../../components/CTA";
import {
  useSEO,
  buildLanguageAlternates,
  createOrganizationSchema,
} from "../../hooks/useSEO";

export function HomePageDE() {
  const { language, t } = useLanguage();

  const structuredData = useMemo(
    () => [
      createOrganizationSchema(t("seo.organization.description")),
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "@id": "https://fures.at/de#localbusiness",
        name: "Fures Tech",
        description: t("seo.organization.description"),
        url: "https://fures.at/de",
        telephone: "+4366499735268",
        email: "office@fures.tech",
        address: {
          "@type": "PostalAddress",
          streetAddress: "Maria Alm",
          addressLocality: "Maria Alm",
          addressRegion: "Salzburg",
          postalCode: "5761",
          addressCountry: "AT",
        },
        geo: {
          "@type": "GeoCoordinates",
          latitude: 47.3833,
          longitude: 12.8833,
        },
        areaServed: ["AT", "DE", "CH"],
        serviceType: [
          "Hotel Website Design",
          "Local SEO",
          "Social Media Management",
          "Hotel PMS Integration",
        ],
        inLanguage: ["de-AT", "en"],
      },
    ],
    [language, t]
  );

  useSEO({
    title: t("seo.home.title"),
    description: t("seo.home.description"),
    keywords: t("seo.home.keywords")
      .split(",")
      .map((k) => k.trim())
      .filter(Boolean),
    canonicalPath: "/de",
    language: "de",
    alternates: buildLanguageAlternates("/de"),
    openGraph: {
      title: t("seo.home.title"),
      description: t("seo.home.description"),
      siteName: t("seo.site_name"),
    },
    twitter: {
      title: t("seo.home.title"),
      description: t("seo.home.description"),
    },
    structuredData,
  });

  return (
    <>
      <HeroDE />
      <WhyUs />
      <Services />
      <CTA />
    </>
  );
}
